import { cn } from '@nt/ui/cn'
import { inputVariants } from '@nt/ui/field'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

// The multi-line Input: the same @nt/ui control look, growing with its text.
const textareaVariants = cva(`${inputVariants({ kind: 'textarea' })} flex field-sizing-content min-h-16`, {
  variants: {
    variant: {
      default: '',
      emphasis: 'hover:border-primary',
      brand: 'hover:border-primary',
      accent: 'hover:border-primary',
      // Onboarding forms: a single-line-height field with a lighter placeholder, so example
      // text never reads as data (ob-04 D3, same as Input's `field`; ob-08 F2 for the padding).
      field: 'py-2 placeholder:text-muted-foreground/70',
    },
    size: {
      default: '',
      // Exactly one line in a control-height field (of-6 V1). overflow-hidden clips at the
      // padding edge, so any vertical padding lets the top of line 2 through; with none and a
      // line as tall as the inner box (the control height minus the 1 px borders), line 2 starts
      // at the clip edge and line 1 stays centred.
      line: 'h-control min-h-0 py-0 leading-[calc(var(--nt-control-h)-2px)]',
    },
  },
  defaultVariants: { variant: 'default', size: 'default' },
})

function Textarea({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>) {
  return <textarea data-slot="textarea" className={cn(textareaVariants({ variant, size, className }))} {...props} />
}

export { Textarea, textareaVariants }
